/**
 * Created on 16/8/19.
 */
export default {
    name: 'GENERAL INFORMATION',
    rows: {
        'property-name': {
            name: 'Property Name',
            editable: true,
            value: '',
        },
        'address': {
            name: 'Address',
            type: 'link',
            editable: true,
            value: '',
        },
        'google-maps-link': {
            name: 'CAD Link',
            type: 'link',
            editable: true,
            value: '',
        },
        'city': {
            name: 'City',
            editable: true,
            value: '',
        },
        'state': {
            name: 'State',
            editable: true,
            value: '',
            type: 'dropdown',
            dropdownValues: '',
        },
        'zip': {
            name: 'ZIP',
            editable: true,
            value: '',
        },
        'appraised-value': {
            name: 'Appraised Value',
            editable: true,
            unit: '$',
            type: 'number',
            value: '',
        },
        'analysis-date': {
            name: 'Analysis Date',
            editable: true,
            type: 'date',
            value: '',
        },
        'market': {
            name: 'Market',
            editable: true,
            value: '',
            type: 'dropdown',
            dropdownValues: '',
        },
        'property-category': {
            name: 'Property Category',
            editable: true,
            value: '',
            type: 'dropdown',
            dropdownValues: '',
        },
        'property-type': {
            name: 'Property Type',
            editable: true,
            value: '',
            type: 'dropdown',
            dropdownValues: '',
        }
    }
};